import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkaregaonmidc() {



const cardData =
  {
    keyword: 'Bus On Rent in Karegaon MIDC',
    heading: 'Sanavi Travels: Bus On Rent in Karegaon MIDC',
    headingDescription: 'Sanavi Travels offers dependable, professionally managed, and cost-effective Bus On Rent in Karegaon MIDC, catering to industrial employees, corporate teams, factory staff, vendors, families, wedding groups, schools, and outstation travelers. Karegaon MIDC is an important industrial and employment zone located near Shirur and Ranjangaon, hosting multiple manufacturing units, warehouses, and small-to-medium enterprises with regular shift-based operations. Daily employee movement, factory shift transport, corporate meetings, training programs, vendor visits, and inspection travel make organized group transportation essential in this region. Sanavi Travels provides a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses designed specifically for industrial and long-distance usage. Each vehicle is maintained with clean interiors, comfortable push-back seating, strong suspension for highway and industrial roads, proper ventilation, and sufficient luggage space for staff belongings. Our experienced drivers are well familiar with Karegaon MIDC internal roads, factory gates, Shirur and Ranjangaon routes, and major highways, ensuring disciplined driving, punctual pickups, and smooth shift change operations. With flexible rental plans, transparent pricing, and 24/7 customer support, Sanavi Travels makes bus rental in Karegaon MIDC reliable, economical, and completely stress-free for all industrial and group travel requirements.',

    top: 'Top Places to Visit Near Karegaon MIDC with Sanavi Travels',


"topPlaces": [
  {
    "title": "Karegaon MIDC Industrial Area",
    "description": "Karegaon MIDC is a growing industrial zone with multiple factories, warehouses, and production units operating on rotational shifts. Daily employee transportation is critical here, and bus rental services ensure punctual arrivals, disciplined travel routines, and reduced dependence on private vehicles. Organized bus transport improves safety, reduces traffic congestion, and supports smooth industrial operations."
  },
  {
    "title": "Shirur Town",
    "description": "Shirur serves as the nearest commercial and residential hub for Karegaon MIDC employees. Workers and families regularly travel to Shirur for housing, education, healthcare, shopping, and banking. Bus hire services provide economical and reliable group travel between Karegaon MIDC and Shirur."
  },
  {
    "title": "Ranjangaon MIDC Connectivity",
    "description": "Karegaon MIDC is closely connected to Ranjangaon MIDC, allowing inter-industrial movement for meetings, audits, training programs, and vendor coordination. Bus rentals help companies manage group transportation efficiently across industrial corridors."
  },
  {
    "title": "Pune–Ahmednagar Highway",
    "description": "The Pune–Ahmednagar highway plays a crucial role in connecting Karegaon MIDC with Pune city and Ahmednagar district. Corporate travel, logistics support, and long-distance employee transport frequently use this route, making buses a safe and cost-effective option."
  },
  {
    "title": "Employee Residential Villages",
    "description": "Many employees working in Karegaon MIDC reside in nearby villages and rural pockets. Daily commute buses ensure safe, timely, and fatigue-free transportation for workers traveling early morning or late night shifts."
  },
  {
    "title": "Corporate Training and Meeting Locations",
    "description": "Industries around Karegaon MIDC frequently conduct training sessions, safety workshops, and induction programs. Bus hire services enable bulk employee movement for these programs in an organized manner."
  },
  {
    "title": "Wedding and Social Event Venues",
    "description": "Local residents and factory employees often organize weddings and social events in nearby villages and towns. Hiring buses ensures smooth guest transportation and reduces coordination challenges during large gatherings."
  },
  {
    "title": "Picnic and Team Outing Spots",
    "description": "Companies and families from Karegaon MIDC plan picnics and team outings to nearby leisure destinations. Bus rentals allow groups to travel together safely while enjoying a relaxed journey."
  },
  {
    "title": "Outstation Corporate Routes",
    "description": "Karegaon MIDC acts as a starting point for outstation travel to Pune, Mumbai, Nashik, and Ahmednagar. Bus rentals provide a comfortable and economical solution for long-distance group travel."
  },
  {
    "title": "Rural and Industrial Workforce Connectivity",
    "description": "Karegaon MIDC bridges rural employment with industrial growth. Bus rental services support reliable daily transportation for the workforce, improving productivity and attendance."
  }
]
,



"services": [
{
"name": "Bus On Rent in Karegaon MIDC",
"description": "Bus On Rent in Karegaon MIDC provides professionally managed, safe, and reliable transportation for factory employees, corporate teams, vendors, and group travelers. This service is ideal for daily employee shift movement, corporate meetings, training programs, factory audits, weddings, picnics, and long-distance journeys. Our buses are equipped with clean interiors, comfortable push-back seating, strong suspension suitable for industrial and highway roads, proper ventilation, and sufficient space for staff belongings. Experienced drivers familiar with MIDC layouts, factory gates, and shift schedules ensure punctual pickups, disciplined driving, and smooth operations. This service helps companies reduce logistical challenges while maintaining employee safety and comfort."
},
{
"name": "Bus Hire Karegaon MIDC",
"description": "Bus Hire Karegaon MIDC offers flexible transportation solutions for industries, contractors, and organizations. Whether it is daily employee transport, short-term project travel, or special corporate events, this service ensures organized, economical, and dependable group movement."
},
{
"name": "AC Bus Rental Karegaon MIDC",
"description": "AC Bus Rental Karegaon MIDC is ideal for long-distance corporate travel and summer shifts, providing air-conditioned comfort that minimizes fatigue and improves overall travel experience for employees."
},
{
"name": "Non AC Bus on Rent Karegaon",
"description": "Non AC Bus on Rent Karegaon provides cost-effective transportation for short routes, nearby villages, and daily workforce travel while maintaining safety and cleanliness standards."
},
{
"name": "Luxury Bus on Rent Karegaon MIDC",
"description": "Luxury Bus on Rent Karegaon MIDC offers premium transportation for senior executives, visiting clients, auditors, and VIP guests, featuring superior interiors, enhanced seating comfort, and professional presentation."
},
{
"name": "Mini Bus Hire Karegaon",
"description": "Mini Bus Hire Karegaon is suitable for smaller teams, departmental travel, training batches, and vendor visits, offering flexibility and easy maneuverability within industrial areas."
},
{
"name": "32 Seater Bus on Rent Karegaon",
"description": "32 Seater Bus on Rent Karegaon is ideal for medium-sized employee groups, balancing seating capacity with comfort for daily shifts and short outstation trips."
},
{
"name": "35 Seater Bus Hire Karegaon MIDC",
"description": "35 Seater Bus Hire Karegaon MIDC supports large workforce transportation, factory events, and organized group travel requirements efficiently."
},
{
"name": "Bus on Rent Karegaon for Wedding",
"description": "Bus on Rent Karegaon for Wedding ensures smooth and coordinated transportation for wedding guests, helping families and employees manage large gatherings without travel stress."
},
{
"name": "Bus on Rent Karegaon for Corporate",
"description": "Bus on Rent Karegaon for Corporate provides structured and professional transport for meetings, conferences, plant visits, and employee engagement programs."
},
{
"name": "Bus on Rent Karegaon for Picnic",
"description": "Bus on Rent Karegaon for Picnic offers safe and enjoyable group travel for factory outings, team-building programs, and family leisure trips."
},
{
"name": "Bus Rental Karegaon MIDC Outstation",
"description": "Bus Rental Karegaon MIDC Outstation provides dependable long-distance transportation to Pune, Mumbai, Nashik, Ahmednagar, and other business destinations."
},
{
"name": "Bus Hire Karegaon with Driver",
"description": "Bus Hire Karegaon with Driver offers chauffeur-driven buses where trained drivers manage traffic, route planning, and schedules efficiently."
},
{
"name": "Affordable Bus Rental Karegaon MIDC",
"description": "Affordable Bus Rental Karegaon MIDC delivers cost-effective transportation solutions without compromising safety, punctuality, or vehicle quality."
},
{
"name": "Best Bus Service Karegaon",
"description": "Best Bus Service Karegaon is trusted by industries and organizations for punctual operations, clean buses, transparent pricing, and reliable service provided by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Karegaon MIDC", "Bus Hire Karegaon MIDC"],
["AC Bus Rental Karegaon", "Non AC Bus Hire Karegaon"],
["Luxury Bus Karegaon", "Mini Bus Hire Karegaon"],
["32 Seater Bus Karegaon", "35 Seater Bus Karegaon"],
["Corporate Bus Karegaon", "Wedding Bus Karegaon"],
["Picnic Bus Karegaon", "Outstation Bus Karegaon"],
["Bus Hire Karegaon with Driver", "Affordable Bus Rental Karegaon"],
["Best Bus Service Karegaon", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Karegaon MIDC with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels specializes in industrial and corporate bus transportation in Karegaon MIDC."
  },
  {
    "WhyChooseheading": "Industrial Route Expertise",
    "WhyChoosedescription": "Drivers are trained and familiar with MIDC layouts, factory gates, and shift timings."
  },
  {
    "WhyChooseheading": "Clean and Reliable Fleet",
    "WhyChoosedescription": "All buses are maintained to meet corporate safety and hygiene standards."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing structure with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Dedicated assistance for corporate coordination and emergencies."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Daily, monthly, and customized industrial contracts available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Regular sanitization ensures workforce safety."
  },
  {
    "WhyChooseheading": "On-Time and Disciplined Service",
    "WhyChoosedescription": "Strict adherence to schedules and punctual operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Karegaon MIDC?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services in Karegaon MIDC.'
  },
  {
    question: 'Are buses available for daily employee transportation?',
    answer: 'Yes, we provide daily, monthly, and contractual employee transport services.'
  },
  {
    question: 'Can buses be hired for corporate outings and weddings?',
    answer: 'Yes, buses are available for corporate outings, weddings, and social events.'
  },
  {
    question: 'Are drivers trained for industrial routes?',
    answer: 'Yes, our drivers are experienced with MIDC and highway routes.'
  },
  {
    question: 'Is outstation bus rental available from Karegaon MIDC?',
    answer: 'Yes, outstation travel services are available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Shinde',
    feedback: 'Sanavi Travels handles our employee transport in Karegaon MIDC very efficiently.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'We booked a bus from Karegaon MIDC for a corporate picnic. Excellent service.',
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Karegaon MIDC - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Karegaon MIDC for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Karegaon MIDC | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Karegaon MIDC with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/236.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkaregaonmidc;